// @ts-nocheck

export const localeCodes =  [
  "en",
  "ar",
  "he",
  "ru",
  "zh",
  "fr",
  "de",
  "es",
  "it",
  "pt",
  "tr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_aaForms_46json_49502480",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_9b813e50",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_e438e701",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_9d0a2886",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_7c5c2b6d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_de18f555",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_8d5271a9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_b533702d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_de83e6ae",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_6d2fd7e4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_130069b1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_4821644b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_7bb597fd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_5e59ce8d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_daef91d0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_695f350f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_4325dc2f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_28940b93",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_a50ad0b7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_fdad0322",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_345fba0f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_215fb952",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_ced7937d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_50c5678e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_3e5807ab",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_cb7fdb69",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_d7dd8b3e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_1004a8c7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_587a7a48",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_f41c26fe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_c00afa81",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_d4c2527f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_5e27dfc5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_60bef907",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_17fca704",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_0e380f48",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_11c99859",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_180d6194",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_0adfd703",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_86af4d39",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_2263eb16",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_a2548964",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_11ba64bd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_9dd54f2e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_7552eba4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_98952049",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_5b099296",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_6bee4b8a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_747dc2cd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_434a202e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_c7696b54",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_ccc915b5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_d7278598",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_131235c1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_1cfa5e6b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_3a01a88e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_c8f27e45",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_8a7ee279",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_26f120af",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_a36906e2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_5bea4521",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_6df65588",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_d0b30e68",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_c12b7ef7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_fc8956bd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_921991c6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_bc0eff5e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_69a5026e",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_aaForms_46json_dab8c954",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_42990987",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_c73b632a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_6addfe0f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_792dbbb2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_fcad45cb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_492c3754",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_ae0d3e22",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_16cd7bbd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_46c1c87d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_2591ed22",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_106ae120",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_1106f1ec",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_b64f7134",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_41eb1c0b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_2b9d62b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_5851b635",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_17c008ee",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_ddf92463",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_01cf418c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_53b4c33a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_03aaa999",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_6551858b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_44df87da",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_196071b7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_cec1d3d3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_6e743f55",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_930b3053",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_3ef8f207",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_c75529ac",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_e4893fab",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_ff38ba0d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_0245f34a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_095d8696",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_d7b93ce9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_148f2864",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_689ca375",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_528e2717",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_bbd56547",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_370633ee",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_0f250fcc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_3bffe5f2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_74280e2d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_51b46de3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_a12ab2ab",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_55b6bf09",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_26daec9f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_07583766",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_5b8e0805",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_e71db40d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_fc0dd010",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_09b69c41",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_9adcdaea",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_0d417395",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_7691b714",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_0a8d8632",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_3a3c178c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_820d82b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_36efaf60",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_3577c6c6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_f5cf702b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_dcbefcbf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_ab4b193e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_995efc29",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_f6c7d3b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_121733aa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_324a4415",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_789eb898",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_aaForms_46json_0c62f009",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_67b433b7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_5da76433",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_03dd1343",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_a952ca90",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_b9eee40d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_3e2007d5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_7e452fe6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_d70bad0e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_c56541ca",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_4d5aded3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_63a4f93d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_2845d184",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_c8757910",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_880f83d1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_c9ca874c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_f23f7829",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_fb1b7b90",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_13445de2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_4c5fdce4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_be026fd0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_68bd9d36",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_7f5a19f0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_af69521e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_c066978b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_7fcd75ed",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_43cd1623",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_35f6b1a8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_c8815185",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_d91c0657",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_df98f42a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_7c847543",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_1069ed81",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_0761d986",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_dcf7bce7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_bfe53e26",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_933d69a2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_70962f52",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_84516f3f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_92d624d0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_573abd74",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_f9c74c60",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_1d8bf096",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_884f8454",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_f84bd595",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_e861179c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_8234fb94",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_7bd59973",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_dfc758af",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_4c06b634",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_619fd4f8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_0e8868a8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_8aadb228",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_e1d27837",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_a268394b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_979d4781",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_5c54ac63",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_e4efe1eb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_b0b4d84f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_937fc39e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_197b72e8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_2b9fa0b8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_7af155d6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_fcc0e062",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_1b556a51",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_a7279916",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_2bee4589",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_3e7a69b2",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_aaForms_46json_8817e12a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_b6bb08b1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_1bd20d8b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_8b518ab3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_0c31494d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_e9ed58bf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_fc57b22b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_1ee33869",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_04b040c0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_0a36dac1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_7f4d9da0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_0f8cadec",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_8b272bfa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_c4749e1c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_e71ecdba",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_840ea624",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_9fd1710c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_a5ee58d4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_7d1b31f0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_77877979",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_47e2569c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_fa8553a8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_4058fddb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_d2fbcc4c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_82e76397",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_ce39ca53",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_a3d4b002",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_20e15e64",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_69993b42",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_03cdb614",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_08112246",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_c7964671",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_278ab1e7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_4bab4224",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_276fd9cb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_d6e5512e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_a01e0dbf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_07cfae20",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_56feb0a7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_c3fc97dc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_047e36ed",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_f0ebc495",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_bbf683b1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_7773a895",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_caba278a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_6dc07f2d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_61cede1a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_aaaf2f7c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_b04ba8f0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_7863840d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_0af77068",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_45967dc5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_df1f19b2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_54be213e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_74555b69",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_29505694",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_f5493b85",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_f32d9384",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_71dac41b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_417924fe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_1bba5650",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_2396e211",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_e8416577",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_86ec2b90",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_4ead433d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_47430ab9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_dd9c131e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_7f8c99cf",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_aaForms_46json_1425e9b6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_98f6d1bf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_49eb8d2f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_deeee6c1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_a501663b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_296d3450",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_f8665b32",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_8315a787",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_0e3939fb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_5a2776e3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_a97030a2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_7e00cdd1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_6bc669c3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_25372ae0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_ef2cb515",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_e917834a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_23776239",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_49347d05",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_b36b71fb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_e0dc920c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_dfeaf42b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_fe071f0d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_70c1bdcd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_8cd52386",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_6c9979ee",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_8bd424d7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_350f2c3f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_b6eaa978",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_a0b433be",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_74a4e03a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_9b8850a5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_06f1cd01",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_1727820b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_386e2a56",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_1d53ca0a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_b3552834",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_7db0d747",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_aa1bd1a4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_5b800c89",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_2fd94c34",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_993e5fc7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_3c3fed39",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_1aa8b9b2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_44839abd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_a21da933",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_d4e11283",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_a6a561a9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_3869cd13",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_e408f829",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_7bb3838f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_2d18827b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_220f4098",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_98a8f995",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_e8eae63b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_3ab31ca9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_cf1ea605",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_979d72a2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_f4ef9411",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_6906cb78",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_3144a4a9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_a3cf3681",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_e01caaa0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_27df0537",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_4eda7172",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_43f4d60f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_90514806",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_364a06f9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_ddbaf716",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_aaForms_46json_14a862ae",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_b44cf1da",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_1179dc0e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_dc2dc407",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_57870d1c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_e09fd5dd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_515342dd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_306b448a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_d721720c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_046cb962",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_cef2a4b1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_353bdc93",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_e9a40d8a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_2dd2879b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_dcf84a10",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_2da5e7ef",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_5cfa73a9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_eb3e3685",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_a4f7b94b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_a34a501f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_c3748ded",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_0b37373b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_9f4f9e20",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_45d08385",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_722728dc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_c399dcb0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_01983cfb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_a7ef7c3e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_975b4192",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_7a740aef",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_e18bbca2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_f8a739df",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_d8686be3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_f63c7ba5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_f6004bb4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_a7ec4120",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_b02fb649",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_4bfe9b0e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_2614ab3f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_e1c50c35",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_40baf9dc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_044a5db1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_6c3c7817",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_3884a86d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_5ccf296f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_d39bdf83",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_39a6e5ed",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_adc6886f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_57655460",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_8946bfb4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_7ee213fd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_3cb41fbe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_3dc703a0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_41cf82e5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_2dd6d5b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_9a4d9548",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_322a248c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_94b5659d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_7cd0e677",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_d0b46b0e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_2881de24",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_53d86fe0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_1354fb7d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_2f60ca77",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_7f6d4f0b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_80e98ebd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_719985f8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_86d9c3a4",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_aaForms_46json_a7a0fb46",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_98f417cf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_14ab0faa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_97192cdd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_fe79c3b6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_b3e4d518",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_58ffa26b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_7d56f65a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_a5221744",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_d4b7c545",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_3202fb1f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_43fc380e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_76f5c2c1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_c45ccf4c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_300ea3f9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_eb8523d1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_99657622",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_72a49b8a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_9bc4acda",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_1466a468",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_0e2066cf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_b053729f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_31bdb202",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_153bd219",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_cd404437",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_f9712e46",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_a8093f76",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_386173be",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_8424e4f5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_eca2f54d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_a8bedc36",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_0cb8a146",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_229a7290",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_59a30b38",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_ad30663f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_88b96e45",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_23f04235",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_53815297",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_9f071d6d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_c4eb4480",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_f91f2cec",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_46b48a2c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_606f8fcc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_da43f8a3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_112b37b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_985cae6a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_1fa96d54",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_3b1fccfd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_98152018",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_39407e9e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_58f78cc6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_4914582f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_92cfd63a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_c291aecd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_86f38cae",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_352f9e6e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_c2ba6149",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_8fe626aa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_caac9c0b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_57ca177e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_d7401744",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_e4af9828",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_de065447",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_0537fb55",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_47740432",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_6989ea2d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_48a72678",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_62313ec4",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_aaForms_46json_0a0737ff",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_78378f96",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_ce633198",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_27944962",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_2e49599a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_f6f63dc1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_c2f7ce6b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_5a26b65b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_c0fea9bb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_77362f86",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_8515169c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_bc874587",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_0b79164e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_45aad361",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_6428549c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_19a16db6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_a7c7d117",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_de521304",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_af6cd1d4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_e992c814",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_509d9486",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_1cd304a6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_141b27eb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_34472e99",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_c2755f33",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_af470594",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_5220047e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_27726ceb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_b6d16e00",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_1d164323",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_9b2a16da",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_72ff2916",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_b5109215",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_c31ee37d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_a46b30e0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_637604e4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_f79aa596",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_16e0ad89",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_8800cbae",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_7a62d7a1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_34e355d7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_72e0ae9b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_5b79d355",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_ca2b641e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_7ba9fd9f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_1aa1e06c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_7777359e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_cc352965",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_7fa7d7a8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_a8f62b60",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_3bee5f52",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_41a6e0bd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_5aa7e2b2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_6675ea2d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_596052cb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_2095ccf1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_087ca813",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_f3432e4d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_56432fc7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_85e350be",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_2f08d0d8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_dce67dae",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_0d3f865c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_5985d44c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_0354c52e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_8df2db76",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_789efc8f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_8f21ff19",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_aaForms_46json_2c0b6d7f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_af0db6ed",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_703fced1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_a54b4a76",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_1e261e74",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_de056c11",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_8c897f9f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_4643456e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_51217b28",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_56df1b63",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_cba041b5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_3c5ed1b5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_08a38370",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_dac8c8f7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_64b55077",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_692f91de",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_0c952762",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_c17292fb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_6286e342",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_d6e3506b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_0f2fe263",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_818f1f22",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_427de12a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_fb789d4b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_cb741e64",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_a59e7590",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_64508d96",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_61495e42",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_c521a8d7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_45198e4c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_660f9b83",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_83391d0b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_645a064e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_25a3605e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_f6769f95",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_6e0a8273",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_bf78e9e3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_2e651d2d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_e81905dd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_00ef7c99",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_2ab715b9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_14a9754d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_9605704a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_3a83935a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_309ad436",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_1e4fdce9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_c6f961e8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_1c8a0b14",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_0d3303bd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_76a37639",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_c90a6e5f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_b6c62098",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_a106660f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_02b55fe0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_37b41497",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_4e4ca529",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_d7a4f9d4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_dba1aab7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_55edf026",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_7d658835",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_a0302f09",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_e57ccd55",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_4271c16d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_19ff66fe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_d3359354",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_97f9b41e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_8eb8f8b7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_1ec43201",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_aaForms_46json_f53dcf32",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_4c93f775",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_b2f214f5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_04bb9e68",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_27b35755",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_91698c78",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_0e032b6d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_aac04adf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_dbcf4935",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_2ed24a7a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_a656a2c6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_a83dc758",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_f3399c82",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_00e3bf05",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_fe16e54b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_6469b91b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_66cfc587",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_25a89767",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_50bbd3b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_cd3555b6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_d9f1b1bc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_25da8812",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_5ea7d1fe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_8ba96127",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_5f46f3b3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_d99e82ed",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_08374ec6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_57b968f6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_fca702ac",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_7c217f4d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_4bf1b61b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_d4c38dc9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_b03fffe3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_5d7878fc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_699a9804",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_b463b6a4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_ffb900eb",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_dd0e29a4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_2e42942f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_0d593c09",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_2c1c48e3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_2295aff9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_7dcf5014",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_43a73e03",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_0230e2c2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_1deb5b81",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_5557d917",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_08f593e8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_0e468227",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_d4f74c82",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_597c8462",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_210cb072",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_713ae220",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_da7dbebf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_133d430c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_e2a94c40",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_27370c59",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_0230e47f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_d3e7f3e2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_5c22ded3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_fc0fa1f3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_ebf1d942",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_0b50ef0e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_65701407",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_7ed294fa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_88652748",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_109f15ea",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_5846fa29",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_aaForms_46json_fa44e409",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amAssignment_46json_55e49a55",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amNoteCrm_46json_c8a14d20",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeam_46json_8bfc8937",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamAdmin_46json_fe0e12c5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_amTeamManagers_46json_1d71bfba",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_appointments_46json_ae8ecd67",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ask_46json_72918e17",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_audienceFilters_46json_4a3a17e9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_eb49ac54",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2b_46json_0084e4a5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bAdmin_46json_6ec25241",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bClients_46json_c03ed793",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDashboard_46json_488de544",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDeals_46json_956fc752",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bDealsAdmin_46json_a00bb54d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_b2bPayouts_46json_c3933d51",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_billing_46json_d45715f9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBroke_46json_db480721",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokeAdmin_46json_aaf32953",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_coBrokePayouts_46json_c37c4cc6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commissionRates_46json_32d5bad9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_common_46json_de89706e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_contracts_46json_c036a825",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_10b30bed",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_deals_46json_d1aebd1d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dealsRegister_46json_918e5f3b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAccount_46json_0e66b420",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepAdmin_46json_52036883",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepNews_46json_6a2865dd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepPresentations_46json_9644db59",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_devRepProjects_46json_f3132881",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_emails_46json_9907c2ee",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_errors_46json_74834e66",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusiveUnits_46json_af54bf6e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_exclusives_46json_50c0e64d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_explore_46json_6b6d792f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_help_46json_18b83352",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_landing_46json_554abacd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_learn_46json_c6150bea",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_legal_46json_50234365",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_listings_46json_a94fe022",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_marketing_46json_a261d48d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_masterclass_46json_a170194f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nav_46json_8c2efc60",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_news_46json_24dc17a7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_onboarding_46json_15fd2b7a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_payments_46json_29064cdd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_portfolio_46json_836804c6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_profile_46json_280ef253",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_property_46json_2d2a67c3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_adf643d9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pushAdmin_46json_ac962705",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_rankings_46json_63d23e78",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_referrals_46json_14bd8790",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_saas_46json_a5a06db0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_services_46json_57b66405",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrders_46json_6e740aaf",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersAdmin_46json_edf36f25",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_servicesOrdersStaff_46json_4b0af869",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_shell_46json_2d57f6ad",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_staffLink_46json_075ceaf9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_trainingMaterialsAdmin_46json_50e4683b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeAdmin_46json_0546a06f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeDashboard_46json_02d3088f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeIdentity_46json_452783ff",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uaeJoin_46json_472a74b1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_validation_46json_963a7568",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/a897387c" /* webpackChunkName: "config_i18n_46config_46ts_a897387c" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    dir: "ltr",
    name: "English",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ar",
    language: "ar-AE",
    dir: "rtl",
    name: "العربية",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "he",
    language: "he-IL",
    dir: "rtl",
    name: "עברית",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ru",
    language: "ru-RU",
    dir: "ltr",
    name: "Русский",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "zh",
    language: "zh-CN",
    dir: "ltr",
    name: "简体中文",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    language: "fr-FR",
    dir: "ltr",
    name: "Français",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    language: "de-DE",
    dir: "ltr",
    name: "Deutsch",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    language: "es-ES",
    dir: "ltr",
    name: "Español",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    language: "it-IT",
    dir: "ltr",
    name: "Italiano",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pt",
    language: "pt-PT",
    dir: "ltr",
    name: "Português",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "tr",
    language: "tr-TR",
    dir: "ltr",
    name: "Türkçe",
    domains: [],
    defaultForDomains: []
  }
]

